export class Country {
  id: string;
  code: string;
  name: string;
}
